module.exports = __webpack_public_path__ + "static/img/3327_phase_function_Paper_Points.a40143c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3327_phase_function_Paper_Points.png
// module id = mmS3
// module chunks = 0